var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _line, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 52,
    viewBox: "0 0 61 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4.67676,
    width: 58.0882,
    height: 46.3235,
    rx: 3,
    stroke: "#AB9834",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2646,
    y: 23.7939,
    width: 10.2941,
    height: 7.35294,
    rx: 3,
    stroke: "#AB9834",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2646,
    y: 34.8232,
    width: 10.2941,
    height: 7.35294,
    rx: 3,
    stroke: "#AB9834",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41.4414,
    y: 23.7939,
    width: 10.2941,
    height: 7.35294,
    rx: 3,
    stroke: "#AB9834",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41.4414,
    y: 34.8232,
    width: 10.2941,
    height: 7.35294,
    rx: 3,
    stroke: "#AB9834",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.08838,
    y: 23.7939,
    width: 10.2941,
    height: 7.35294,
    rx: 3,
    stroke: "#AB9834",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.08838,
    y: 34.8232,
    width: 10.2941,
    height: 7.35294,
    rx: 3,
    stroke: "#AB9834",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 15.4414,
    x2: 59.0882,
    y2: 15.4414,
    stroke: "#AB9834",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2354 7.61719L39.2354 0.999541",
    stroke: "#AB9834",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5884 7.61719L21.5884 0.999541",
    stroke: "#AB9834",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterDate);
export default __webpack_public_path__ + "static/media/footer-date.a896ca3d3acf7a6b4f735017ce65e9d2.svg";
export { ForwardRef as ReactComponent };